module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#shortform",
      toString: function () {
        return this.url;
      }
    }